<template>
  <section id="certificates" class="certificates-page">
    <div class="container">
      <div class="page-header">
        <a href="/" class="back-link">
          <font-awesome-icon icon="chevron-left" /> Back to Home
        </a>
        <h1 class="page-title">Certificates</h1>
      </div>

      <div class="certificates-grid">
        <div
          class="certificate-card"
          v-for="certificate in certificates"
          :key="certificate.id"
          @click="openCertificateLink(certificate.link)"
        >
          <div class="certificate-content">
            <h3 class="certificate-title">{{ certificate.title }}</h3>
            <p class="certificate-issuer">{{ certificate.issuer }}</p>
            <div class="certificate-date">
              <font-awesome-icon icon="external-link-alt" class="mr-2 h-3 w-3" />
              <span class="date-text">{{ certificate.date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CertificatesPage",
  mounted() {
    document.title = "Jayson Gomba - Certificates";
  },
  beforeUnmount() {
    document.title = "Jayson Gomba";
  },
  data() {
    return {
      certificates: [
        {
          id: 1,
          title: "Nuxt 3 Fundamentals",
          issuer: "Frontend Masters",
          date: "2026",
          link: "https://static.frontendmasters.com/ud/c/dee57eadc5/vOVSMmwVVj/nuxt.pdf",
        },
        {
          id: 2,
          title: "Tech Career Skills: Communication for Developers",
          issuer: "LinkedIn Learning",
          date: "2026",
          link: "https://www.linkedin.com/learning/certificates/e1c6c647adc8fa2f43f32591a191e0bc37c9f018c4d5dd1d42dae1da4b54cd27?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BhMy0weQ1TbWtK86jPAFeBg%3D%3D",
        },
        {
          id: 3,
          title: "Cloud Infrastructure: Startup to Scale",
          issuer: "Frontend Masters",
          date: "2026",
          link: "https://www.linkedin.com/learning/certificates/1c8e7b9a0c8f2a3d9b1e5c4f1a2e0b9c37c9f018c4d5dd1d42dae1da4b54cd27?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BhMy0weQ1TbWtK86jPAFeBg%3D%3D",
        },
        {
          id: 4,
          title: "Learning Docker",
          issuer: "LinkedIn Learning",
          date: "2026",
          link: "https://www.linkedin.com/learning/certificates/aa0ca6082eed1299f12ceedf176e3c8626e9f29b0b46abd0cdfd86a99611080f?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BhMy0weQ1TbWtK86jPAFeBg%3D%3Dhttps://www.linkedin.com/learning/certificates/aa0ca6082eed1299f12ceedf176e3c8626e9f29b0b46abd0cdfd86a99611080f?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_certifications_details%3BhMy0weQ1TbWtK86jPAFeBg%3D%3D",
        },
        {
          id: 5,
          title: "Github Foundations",
          issuer: "Github",
          date: "2025",
          link: "https://www.credly.com/badges/e897f710-46d0-4a8b-9c02-bfdb7d6626fe",
        },
        {
          id: 6,
          title: "Vue 3 Fundamentals",
          issuer: "Frontend Masters",
          date: "2025",
          link: "https://static.frontendmasters.com/ud/c/dee57eadc5/VcBlSkIIXh/vue-fundamentals.pdf",
        },
        {
          id: 7,
          title: "Postman API Fundamentals Student Expert",
          issuer: "Postman",
          date: "2025",
          link: "https://badgr.com/public/assertions/2a-r8khDRcuv9HunKhJ59w",
        },
        {
          id: 8,
          title: "IBM Front-End Developer",
          issuer: "IBM",
          date: "2025",
          link: "https://www.coursera.org/account/accomplishments/specialization/AJU6WCIQSPXI",
        },
        {
          id: 9,
          title: "SQL and Relational Databases 101",
          issuer: "Cognitive Class",
          date: "2025",
          link: "https://courses.cognitiveclass.ai/certificates/5c2e370bfaf5463aa34836f8f6cfb7a8",
        },
        {
          id: 10,
          title: "Designing User Interfaces and Experiences (UI/UX)",
          issuer: "IBM",
          date: "2025",
          link: "https://www.coursera.org/account/accomplishments/verify/O1DXY7QBZY1X",
        },
        {
          id: 11,
          title: "Technical Support Fundamentals",
          issuer: "Google",
          date: "2025",
          link: "https://www.coursera.org/account/accomplishments/records/FNJSFT0TW3Q4",
        },
        {
          id: 12,
          title: "Cyber Threat Management",
          issuer: "Cisco",
          date: "2023",
          link: "https://www.credly.com/badges/a33cd381-3c0b-4d56-8c71-5f1ee45899cd",
        },
        {
          id: 13,
          title: "Introduction to Cybersecurity",
          issuer: "Cisco",
          date: "2023",
          link: "https://www.credly.com/badges/ec846f44-d2cf-4ba5-9fa8-78d568be9118",
        },
      ],
    };
  },
  methods: {
    openCertificateLink(link) {
      if (link) {
        window.open(link, '_blank', 'noopener,noreferrer');
      }
    }
  },
};
</script>

<style scoped>
.certificates-page {
  min-height: 100vh;
  padding: 20px 320px;
  background-color: var(--bg-primary);
}

.page-header {
  margin-bottom: 2rem;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  transition: color 0.3s ease;
}

.back-link:hover {
  color: var(--primary-color);
}

.page-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0;
}

.certificates-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.25rem;
  max-width: 1200px;
  margin: 0 auto;
}

.certificate-card {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: var(--border-radius);
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1px solid rgba(255, 255, 255, 0.08);
  cursor: pointer;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
}

[data-theme="light"] .certificate-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.certificate-card::before {
  content: "";
  position: absolute;
  pointer-events: none;
  border-radius: var(--border-radius);
}

[data-theme="light"] .certificate-card::before {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0) 100%
  );
}

.certificate-card:hover {
  background: rgba(255, 255, 255, 0.03);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

[data-theme="light"] .certificate-card:hover {
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.08);
}

.certificate-content {
  padding: 1.25rem 1rem;
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.certificate-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  line-height: 1.3;
}

.certificate-issuer {
  font-size: 0.875rem;
  line-height: 1;
  color: var(--text-secondary);
  margin-bottom: .50rem;
  opacity: 0.85;
  flex: 1;
}

.certificate-date {
  display: flex;
  align-items: center;
  color: var(--primary-color);
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: auto;
}

.date-text {
  opacity: 0.9;
}

@media (max-width: 992px) {
  .certificates-grid {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }
}

@media (max-width: 768px) {
  .certificates-page {
    padding: 24px 16px;
  }

  .page-header {
    margin-bottom: 1.25rem;
  }

  .back-link {
    margin-bottom: 0.5rem;
  }

  .page-title {
    font-size: 2rem;
  }

  .certificates-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .certificate-content {
    padding: 1.25rem;
  }

  .certificate-title {
    font-size: 1rem;
  }

  .certificate-issuer {
    font-size: 0.8rem;
  }

  .certificate-date {
    font-size: 0.75rem;
  }
}

@media (max-width: 576px) {
  .certificate-content {
    padding: 1rem;
  }
}
</style>
